enum NavTypes {
  TASKS,
  DASHBOARD,
  RESOURCES,
  DEALS,
  DEAL,
  TEAM_MANAGEMENT,
  NEW_CUSTOMER,
}

export default NavTypes;
